/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Layout } from './layout';


export interface RT1GenerateResponse { 
    image: string;
    layout: Layout;
    'signature-reason': string;
    'cert-chain': string;
}

